import { render, staticRenderFns } from "./halfCircleBR.vue?vue&type=template&id=283c30b6&"
import script from "./halfCircleBR.vue?vue&type=script&lang=js&"
export * from "./halfCircleBR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports